import React from "react";
import { connect } from "react-redux";
import { getGrupos, eliminarGrupo } from "../usuario/UsuarioService";
import "../../styles/Empresa.css";
import DocumentDialogContent from "./GrupoUsuario";
import GrupoUsuarioDatos from "./GrupoUsuarioDatos";
import MensajeFlash from '../mensajeFlash/MensajeFlash';
import {Modal, Button,Col,Row,Container } from "react-bootstrap";
import  Navbar  from '../home/Navbar';
import ExclamacionIcon from '../../styles/icons/exclamation-circle.svg'
import delete_forever from '../../styles/icons/delete.svg';
import edit from '../../styles/icons/edit.svg';
import visibility from '../../styles/icons/visibility.svg';
import search from "../../styles/icons/search.svg";
import Spinner from "react-bootstrap/Spinner";


class GruposUsuarios extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      dialogTitle: "Registrar nueva Empresa",
      dialogType: "add",
      submitText: "Guardar",
      disabledInput: false,
      selectedGruposUsuarios: {
        id: "",
        descripcion: "",
        activo: false,
        miembros: {}
      },
      dialogIsOpen: false,
      dialogIsOpenVerDatos: false,
      mensajeFlash: "",
      mostrarMensajeFlash: false,
      pageSize: 10,
      loading: true,
      search: ""
    };
    this.tableRef = React.createRef();
  }

  handleDialog = (value, mensaje = "") => {
    if (value === false) {
      this.fetchGrupos(0, this.state.pageSize, "");
      if (mensaje != "") {
        this.setState({
          mostrarMensajeFlash: true,
          mensajeFlash: mensaje
        });
      }
    }
    this.setState({ dialogIsOpen: value });
  };

  handleClickOpen = () => {
    this.setState({
      open: true,
    });
  };

  handleCloseMensajeFlash = () => {
    this.setState({
      mostrarMensajeFlash: false,
    });
  };

  handleDialogVerDatos = (value) => {
    if (value === false) {
      this.fetchGrupos(0, this.state.pageSize, "");
    }
    this.setState({
      dialogIsOpenVerDatos: value,
    });
  };

  handleClose = () => {
    this.setState({
      open: false,
    });
    this.fetchGrupos(0, this.state.pageSize, "");
  };

  handleDisableGrupo=()=>{
    this.handleClose();
    this.props.eliminarGrupo(this.state.selectedGruposUsuarios.id).then((response) => {
      {
        if (response.error) {
          this.setState({
            mensajeFlash: response.mensaje,
            mensajeFlashSeverity: "danger"
          });
        } else {
          this.tableRef.current.onQueryChange();
        }
        this.setState({
          mensajeFlash: response.mensaje,
          mostrarMensajeFlash: true
        });
      }
    })
    this.fetchGrupos(0, this.state.pageSize, "");
  }

  handleNewGrupo = () => {
    this.setState(
      {
        dialogTitle: "Registrar nuevo Grupo",
        selectedGruposUsuarios: {
            id: "",
            descripcion: "",
            activo: false
        },
        dialogType: "add",
        submitText: "Guardar",
        disabledInput: false,
      },
      () => {
        this.handleDialog(true);
      }
    );
  };

  handleVerdatos = () => {
    this.setState(
      {
        dialogTitle: "Detalles Empresa",
        selectedGruposUsuarios: {
            id: "",
            descripcion: "",
            activo: false
        },
        dialogType: "add",
        submitText: "Guardar",
        disabledInput: false,
      },
      () => {
        this.handleDialogVerDatos(true);
      }
    );
  };
    handlePageChange(newPage) {
      if (newPage >= 0 && newPage < this.state.totalPages) {
        this.setState({ page: newPage }, () => {
          this.fetchGrupos(newPage, this.state.pageSize, "");
        });
      }
    }
    componentDidMount() {
      this.fetchGrupos(0, this.state.pageSize, "");
    }
  
    handlePageChange = (newPage) => {
      if (newPage >= 0 && newPage < this.state.totalPages) {
        this.setState({ page: newPage }, () => {
          this.fetchGrupos(this.state.page, this.state.pageSize, "");
        });
      }
    };
  
    handlePageSizeChange = (event) => {
      const newPageSize = parseInt(event.target.value, 10);
      this.setState({ pageSize: newPageSize, page: 0 }, () => {
        this.fetchGrupos(this.state.page, this.state.pageSize, "");
      });
    };
  
    renderPageNumbers() {
      const { page, totalPages } = this.state;
      const maxVisiblePages = 5; // Máximo de páginas visibles
  
      let pages = [];
  
      if (totalPages <= maxVisiblePages) {
        // Mostrar todas las páginas si son pocas
        for (let i = 0; i < totalPages; i++) {
          pages.push(
            <li
              key={i}
              className={`page-item ${page === i ? "active" : ""}`}
              onClick={() => this.handlePageChange(i)}
            >
              <a className="page-link" type="Button">{i + 1}</a>
            </li>
          );
        }
      } else {
        // Mostrar primeras páginas, últimas y cercanas a la actual
        const startPage = Math.max(0, page - 2);
        const endPage = Math.min(totalPages - 1, page + 2);
  
        // Agregar primera página
        if (startPage > 0) {
          pages.push(
            <li
              key={0}
              className={`page-item ${page === 0 ? "active" : ""}`}
              onClick={() => this.handlePageChange(0)}
            >
              <a className="page-link" type="Button">1</a>
            </li>
          );
          if (startPage > 1) {
            pages.push(
              <li key="start-ellipsis" className="page-item disabled">
                <span className="page-link">...</span>
              </li>
            );
          }
        }
  
        // Agregar páginas visibles
        for (let i = startPage; i <= endPage; i++) {
          pages.push(
            <li
              key={i}
              className={`page-item ${page === i ? "active" : ""}`}
              onClick={() => this.handlePageChange(i)}
            >
              <a className="page-link" type="Button">{i + 1}</a>
            </li>
          );
        }
  
        // Agregar última página
        if (endPage < totalPages - 1) {
          if (endPage < totalPages - 2) {
            pages.push(
              <li key="end-ellipsis" className="page-item disabled">
                <span className="page-link">...</span>
              </li>
            );
          }
          pages.push(
            <li
              key={totalPages - 1}
              className={`page-item ${page === totalPages - 1 ? "active" : ""}`}
              onClick={() => this.handlePageChange(totalPages - 1)}
            >
              <a className="page-link" type="Button">{totalPages}</a>
            </li>
          );
        }
      }
  
      return pages;
    }
  
    fetchGrupos(page, pageSize, search) {
      this.setState({ loading: true });
      this.props.getGrupos(page, pageSize, search).then(() => {
        this.setState({
          grupos: this.props.gruposData.grupos,
          page: this.props.gruposData.page,
          totalCount: this.props.gruposData.totalCount,
          totalPages: Math.ceil(
            this.props.gruposData.totalCount / pageSize
          ),
          loading: false,
        });
      });
    }
  
    handleSearchChange = (e) => {
      const searchValue = e.target.value;
      this.setState({ search: searchValue }, () => {
        this.fetchGrupos(0, this.state.pageSize, this.state.search);
      });
    };
  render() {
    return (
      <div>
        <div className="dashboardContent">
          <div className="container-fluid">
          <MensajeFlash 
            mensaje={this.state.mensajeFlash} 
            severity={"success"} 
            open={this.state.mostrarMensajeFlash}
            handleClose={this.handleCloseMensajeFlash}/>
            <Modal
              size="xl"
              aria-labelledby="contained-modal-title-vcenter"
              centered
              show={this.state.dialogIsOpen}
              onHide={this.handleDialog}
              backdrop="static"
              keyboard="false"
            >
              <DocumentDialogContent
                grupo={this.state.selectedGruposUsuarios}
                handleClose={this.handleDialog}
                type={this.state.dialogType}
                submitText={this.state.submitText}
                disabledInput={this.state.disabledInput}
                dialogTitle={this.state.dialogTitle}
              />
            </Modal>
        <Modal
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          show={this.state.dialogIsOpenVerDatos}
          onHide={this.handleDialogVerDatos}
          backdrop="static"
          keyboard="false">
            <GrupoUsuarioDatos
              grupo={this.state.selectedGruposUsuarios}
              handleClose={this.handleDialogVerDatos}
              type={this.state.dialogType}
              submitText={this.state.submitText}
              disabledInput={this.state.disabledInput}
              dialogTitle={this.state.dialogTitle}
            />
          </Modal>
          <Modal
              size="md"
              aria-labelledby="contained-modal-title-vcenter"
              centered
              show={this.state.open}
              onHide={this.handleClose}
              backdrop="static"
              keyboard="false"
            >
              <Container>
                <Modal.Body>
                  <Row className="justify-content-center">
                    <Col className="text-center text-md-right">
                    <img src={ExclamacionIcon} style={{margin: '40px'}}></img>
                    </Col>
                  </Row>
                  <Row className="justify-content-center">
                    <Col className="text-center text-md-right">
                      <p><strong>Estas Seguro que desea eliminar el grupo seleccionado?</strong></p>
                    </Col>
                  </Row>
                  <Row style={{ background: "#EDF2F9" }}>
                    <Col>
                      <p><strong>Descripción:</strong> {this.state.selectedGruposUsuarios.descripcion}</p>
                    </Col>
                  </Row>
                </Modal.Body>
                <Modal.Footer>
                  <Button onClick={this.handleClose} variant="contained">Cancelar</Button>
                  <Button onClick={this.handleDisableGrupo} color="primary" autoFocus>
                    Aceptar
                  </Button>
                </Modal.Footer>
              </Container>
            </Modal>
            <div className="sectionHeader">
              <h1 className="pageTitle"> Grupo Usuarios </h1>
              <div className="actions">
                <Button
                  color="primary"
                  onClick={this.handleNewGrupo}
                >
                  Nuevo Grupo
                </Button>
              </div>
            </div>
            <Navbar
              menuActual={window.location.hash}
              seccionActual={'administracion'}
            />
          <div className="contentBuscador card">
              <form className="searchForm">
                <div className="input-group input-group-lg">
                  <span className="input-group-text border-0" id="basic-addon2">
                    <img src={search} />
                  </span>
                  <input
                    type="search"
                    className="form-control"
                    placeholder="Buscar.."
                    aria-label="Search"
                    aria-describedby="basic-addon2"
                    value={this.state.search}
                    onChange={this.handleSearchChange}
                  />
                </div>
              </form>
            </div>
            <div className="contentPage card" style={{ padding: "0px" }}>
            {this.state.loading ? (
                // Muestra el spinner mientras loading sea true
                <div className="d-flex justify-content-center p-5">
                  <Spinner animation="border" role="status">
                    <span className="visually-hidden">Cargando...</span>
                  </Spinner>
                </div>
              ) : (<div>
              <div className="table-responsive">
                <table className="table table-striped table-hover">
                  <thead>
                    <tr>
                      <th scope="col">Descripcion</th>
                      <th scope="col">Activo</th>
                      <th scope="col">Acciones</th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.props.gruposData.grupos.map((grupo, index) => (
                      <tr key={index}>
                        <th scope="row">{grupo.descripcion}</th>
                        <td>{grupo.activo?"SI":"NO"}</td>
                        <td>
                          <div className="table-actions">
                          <button class="btn btn-secondary btn-md btn-floating" onClick={() => {
                      this.setState({
                        dialogTitle: "Editar Grupo",
                        selectedGruposUsuarios: grupo,
                        dialogType: "edit",
                        submitText: "Editar",
                        disabledInput: false
                      }, () => {
                        this.handleDialog(true);
                      });
                    }}>
                          <img src={edit} />
                          </button>
                          <button class="btn btn-secondary btn-md btn-floating" onClick={() => {
                      this.setState({
                        dialogTitle: "Detalles Grupo",
                        selectedGruposUsuarios: grupo,
                        dialogType: "edit",
                        submitText: "Editar",
                        disabledInput: false
                      }, () => {
                        this.handleDialogVerDatos(true);
                      });
                    }}>
                          <img src={visibility} />
                          </button>
                          <button class="btn btn-secondary btn-md btn-floating" onClick={() => {
                      this.setState({
                        dialogTitle: "Eliminar Aplicacion Externa",
                        selectedGruposUsuarios: grupo,
                        dialogType: "eliminar",
                        submitText: "Eliminar",
                        disabledInput: false
                      }, () => {
                        this.handleClickOpen();
                      });
                    }}>
                          <img src={delete_forever} />
                          </button>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <div id="paginador">
                    <label>
                      Mostrar
                      <select
                        className="form-control custom-select"
                        id="maxRows"
                        name="state"
                        value={this.state.pageSize}
                        onChange={this.handlePageSizeChange}
                      >
                        <option value="5">5</option>
                        <option value="10">10</option>
                        <option value="20">20</option>
                        <option value="50">50</option>
                      </select>
                      resultados.
                    </label>
                    <ul className="pagination mb-0">
                      <li
                        className={`page-item ${
                          this.state.page === 0 ? "disabled" : ""
                        }`}
                        onClick={() =>
                          this.handlePageChange(this.state.page - 1)
                        }
                      >
                        <a className="page-link" type="Button">
                          <span className="material-icons">chevron_left</span>
                        </a>
                      </li>
                      {this.renderPageNumbers()}
                      <li
                        className={`page-item ${
                          this.state.page === this.state.totalPages - 1
                            ? "disabled"
                            : ""
                        }`}
                        onClick={() =>
                          this.handlePageChange(this.state.page + 1)
                        }
                      >
                        <a className="page-link" type="Button">
                          <span className="material-icons">chevron_right</span>
                        </a>
                      </li>
                    </ul>
                  </div>
            </div>)}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  getGrupos: (page, size, search) => dispatch(getGrupos(page, size, search)),
  eliminarGrupo: (id) => dispatch(eliminarGrupo(id)),
});

const mapStateToProps = (state) => ({
  gruposData: state.gruposData,
});

export default connect(mapStateToProps, mapDispatchToProps)(GruposUsuarios);